import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormFieldBase } from '../models/df-field-base';

@Component({
	selector: 'df-field',
	templateUrl: './dynamic-form-field.component.html'
})
export class DynamicFormFieldComponent {
	@Input() field: DynamicFormFieldBase<any>;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	get isValid() {
		return this.config.controls[this.field.key].valid;
	}
}
